import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-frame',
  styleUrl: 'frame.css',
  shadow: false,
})
export class Frame {
  @Prop() n: string = "9";
  @Prop() d: string = '16';

  render() {
    return (
      <div class="frame" style={{'--d': this.d, '--n': this.n}}>
        <slot />
      </div>
    );
  }
}
